// @flow

import { getFeatureFlagsClient } from '@atlassian/mpac-feature-flags';
import { keysToCamelCase } from '@atlassian/mpac-utils/object';

import type { ApplicationConfig } from '../../application-config/types/BootstrapConfig';
import type { AmktBootstrap } from '@atlassian/mpac-api-client';
import type { FeatureFlagsType } from '@atlassian/mpac-ui';
import type { AnalyticsClientInterface } from '@atlassiansox/feature-flag-web-client';

type GetFeatureFlagsArgs = {|
  amktBootstrap: AmktBootstrap,
  analyticsClient: AnalyticsClientInterface,
  applicationConfig: ApplicationConfig,
  sourceQueryParam: string,
|};

export const getFeatureFlags = async ({
  amktBootstrap,
  analyticsClient,
  applicationConfig,
  sourceQueryParam,
}: GetFeatureFlagsArgs): Promise<FeatureFlagsType> => {
  const { ldUserKey: userId } = amktBootstrap;
  const {
    featureFlags: { apiKey, environment },
  } = applicationConfig;

  const client = await getFeatureFlagsClient({
    apiKey,
    environment,
    userId,
    analyticsClient,
    productKey: 'marketplace',
    customAttributes: {
      source: sourceQueryParam,
    },
  });

  const allFlags: FeatureFlagsType = keysToCamelCase(client.getAllFlags().toJS());

  return allFlags;
};
